import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSnat = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-snat';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "m7.08 4.86-1.9 1.9h3.06v1.48l-.59.001c-.819.001-1.321.058-1.77.198a3.82 3.82 0 0 0-2.527 2.701c-.178.733-.103 1.593.204 2.333.347.838 1.132 1.623 1.97 1.97.57.237.849.284 1.823.306l.89.021V20h1.52v-4.24h4.48v1.48h-3.06l1.91 1.91L15 21.06l1.91-1.91 1.91-1.91h-3.06v-1.47l.89-.021c.974-.022 1.253-.069 1.823-.306.838-.347 1.623-1.132 1.97-1.97a3.84 3.84 0 0 0-.035-3.042 3.83 3.83 0 0 0-1.655-1.748c-.617-.329-1.229-.443-2.377-.443h-.616V4h-1.52v4.24H9.76V6.76h3.06l-1.9-1.9A131 131 0 0 0 9 2.96c-.011 0-.875.855-1.92 1.9m10.405 4.941c.772.145 1.509.86 1.693 1.643.126.534.054 1.154-.189 1.612-.165.313-.619.767-.929.931-.407.214-.639.253-1.516.253h-.784V12h-1.52v2.24H9.76V12H8.24v2.24h-.784c-.877 0-1.109-.039-1.516-.253-.31-.164-.764-.618-.929-.931-.269-.509-.326-1.263-.136-1.794.243-.68.895-1.27 1.591-1.439.195-.047 1.103-.057 5.519-.06 3.421-.002 5.36.011 5.5.038"
    })
  }));
});
export default SvgSnat;